const userContract = () => ({
    id: null,
    email: '',
    isActiveSubscription: false,
    isAuthenticated: false
});
  
function createUser(user) {
    return Object.assign(userContract(), user);
};

export {
    createUser
};
